module.exports = __webpack_public_path__ + "img/logo-menu.83990d77.png";